export const LABELS_ERRORS = {
    reqText: "Обов'язкове поле",
    minNumber0: 'Поле не може бути менше 0',
    minNumber1: 'Поле не може бути менше 1',
    minLengthElem1: 'Має бути мінімум 1 елемент',
    mustHaveNumber: 'Має бути числом',
    onlyString: 'Тільки букви',
    valueMinLength2: 'Має складатися мінімум з 2 значень',
    errors: {
        onlyTrackEnvironment: 'Даний сервіс доступний лише в трек середовищі'
    }
}
